import { render } from "./DialogShutUpLiveClass.vue?vue&type=template&id=28286f57&scoped=true"
import script from "./DialogShutUpLiveClass.vue?vue&type=script&lang=js"
export * from "./DialogShutUpLiveClass.vue?vue&type=script&lang=js"

import "./DialogShutUpLiveClass.vue?vue&type=style&index=0&id=28286f57&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28286f57"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QCardActions});
